// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"17d06250","239":"6ff87882","453":"0d256579","732":"ed69ebc4"}[chunkId] + ".chunk.js";
};